<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Chorale" />
        <LaChorale/>
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import FooterComp from '../Layouts/FooterComp'
import LaChorale from './LaChorale.vue';


export default {
    name: 'SecretariatPage',
    components: {
        NavBar,
        PageTitle,
        LaChorale,
        FooterComp,
    }
}
</script>